import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NbAuthOAuth2JWTToken, NbAuthService } from '@nebular/auth';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { WiadomoscService } from '../../../@core/http/wiadomosc.service';
import { TokenPayload } from '../../../shared/models/token-payload.model';
import { Wiadomosc } from '../../../shared/models/wiadomosc.model';

@Component({
  selector: 'ngx-mobile-message-dialog',
  templateUrl: './mobile-message-dialog.component.html',
  styleUrls: ['./mobile-message-dialog.component.scss']
})
export class MobileMessageDialogComponent implements OnInit {
  form: FormGroup;
  token: TokenPayload;
  preselectedRecipient: string;

  constructor(
    private formBuilder: FormBuilder,
    private toastrService: NbToastrService,
    private wiadomoscService: WiadomoscService,
    private translate: TranslateService,
    private dialogRef: NbDialogRef<MobileMessageDialogComponent>,
    authService: NbAuthService,
  ) {
    this.form = this.formBuilder.group({
      cel: new FormControl('', [Validators.required]),
      temat: new FormControl('', [Validators.required]),
      tresc: new FormControl('', [Validators.required]),
    });
    
    authService.onTokenChange()
      .subscribe((token: NbAuthOAuth2JWTToken) => {
        if (token.isValid()) {
          this.token = token.getAccessTokenPayload();
        }
      });
  }

  ngOnInit(): void {
    // Set preselected recipient if provided
    if (this.preselectedRecipient) {
      this.form.patchValue({
        cel: this.preselectedRecipient
      });
    }
  }

  get f() { 
    return this.form.controls; 
  }

  onSubmit(wiadomosc: Wiadomosc, valid: boolean): void {
    this.form.markAllAsTouched();
    if (!valid) {
      return;
    }

    this.wiadomoscService.wyslij(wiadomosc).subscribe(() => {
      this.form.reset();
      this.toastrService.show('', this.translate.instant('komunikat.wiadomosc-wyslana'), { status: 'success' });
      this.close();
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
